import { throwError as observableThrowError, Observable } from "rxjs"
import { Component, Input, OnInit } from "@angular/core"
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { catchError } from "rxjs/operators"
import { Roster } from "../../../../models/roster.model"
import { ShareAssignModalComponent } from "../../../../resource/shared-components/share-assign-modal/share-assign-modal.component"
import { TeacherAssignService } from "../../../../services/teacher-assign.service"
import { GlobalStoreService } from "../../../../services/global-store.service"

@Component({
    selector: "app-assign-modal-content",
    templateUrl: "./assign-modal-content.component.html",
    styleUrls: ["./assign-modal-content.component.less"],
})
export class AssignModalContentComponent implements OnInit {
    @Input() public activeModal: NgbActiveModal = null
    @Input() public activityData: any
    public rosters: Roster[] = null
    public assignedRosters: Roster[] = []
    public step = 1
    public loading: boolean = false
    public error: boolean = false

    constructor(
        private teacherAssignService: TeacherAssignService,
        private modalService: NgbModal,
        private globalStoreService: GlobalStoreService
    ) {}

    public ngOnInit() {
        this.teacherAssignService.getRosterSet().subscribe((rosters) => {
            this.rosters = rosters
        })
    }

    public closeModal() {
        if (this.activeModal) {
            this.activeModal.close()
        }
    }

    public stepChange(step) {
        if (step === 0) {
            const shareAssignModal = this.modalService.open(ShareAssignModalComponent, {
                size: "lg",
                windowClass: "full-screen-modal",
            })
            shareAssignModal.componentInstance.titleToShare = this.activityData.activity.name
            shareAssignModal.componentInstance.resourceCode = this.globalStoreService.currentResource.resourceCode
            this.closeModal()
        }

        if (step === 3) {
            this.saveAssignment()
        }
        this.step = step
    }

    public saveAssignment() {
        this.loading = true
        this.teacherAssignService
            .saveAssignment(this.activityData.activity.code, this.rosters)
            .pipe(
                catchError((error) => {
                    this.error = true
                    this.loading = false
                    return observableThrowError(error)
                })
            )
            .subscribe((rosters: Roster[]) => {
                this.assignedRosters = rosters
                this.loading = false
                setTimeout(() => {
                    this.step = 4
                }, 500)
            })
    }

    public resendRequest() {
        this.saveAssignment()
    }
}
